import React from 'react';
import { RateAdvisor as RateAdvisorModule, Utils } from 'common';

const { RateAdvisor } = RateAdvisorModule;

const {
	Session,
	Util,
	PrintUtil: { isDomesticCountryCode },
} = Utils;

/**
 * Dev note:
 * An issue was discovered in RA using Util.getQueryParamByName
 * in Utils module. See WEBAPPS-31529.
 *
 * Instead of modifying Util.getQueryParamByName in Utils module,
 * which requires QA to run regression testings on projects that
 * reference this method, update this local method for RA so QA
 * can focus on RA testing only.
 */

/**
 * Return the param value in the query string.
 * @param {string} param The parameter in the query string.
 * @return {*}
 */
const getParamValue = param => {
	const regExp = RegExp(`[?&]${param}=([^&]*)`, 'i');
	const match = window.location.href.match(regExp);
	const value = match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';

	// return null value for 'null' string
	return value === 'null' ? null : value;
};

const RateAdvisorWrapper = () => {
	const client = getParamValue('c');
	const countryCode = getParamValue('tcc');
	const shouldShowFCPackage = getParamValue('showFCPackage');
	const shouldShowParcelSelect = getParamValue('showParcelSelect');
	const shouldShowGroundAdvantage = getParamValue('showGroundAdvantage');
	const ratingData = {
		// from address
		fromCity: getParamValue('fc'),
		fromState: getParamValue('fs'),
		fromZip: getParamValue('fz'),

		// to address
		toStreet1: getParamValue('tst1'),
		toStreet2: getParamValue('tst2'),
		toStreet3: getParamValue('tst3'),
		toFullName: getParamValue('tn'),
		toCity: getParamValue('tc'),
		toState: getParamValue('ts'),
		toZip: getParamValue('tz'),
		toCountryCode: getParamValue('tcc'),
		toProvince: getParamValue('tp'),
		toPostalCode: getParamValue('tpc'),

		// weight
		weightOz: Number(getParamValue('woz')),
		weightLb: Number(getParamValue('wlb')),

		// dimensions
		length: Number(getParamValue('dl')),
		width: Number(getParamValue('dw')),
		height: Number(getParamValue('dh')),

		// shipDate
		shipDate: getParamValue('dt'),
		residentialIndicator:
			getParamValue('ri') === 'true' || (countryCode && !isDomesticCountryCode(countryCode)),
	};

	const callback = payload => {
		const { AllowedTargetOrigin } = Session.getSettings();

		if (client === 'winclient') {
			window.external.SetRateAdvisorParams(JSON.stringify(payload));
		} else {
			Util.postMessage(
				{
					type: 'RateAdvisor',
					data: payload,
				},
				AllowedTargetOrigin
			);
		}
	};

	const showFCPackage = shouldShowFCPackage === 'true';
	const showParcelSelect = shouldShowParcelSelect === 'true';
	const showGroundAdvantage = shouldShowGroundAdvantage === 'true';

	const OS = Util.getOS().replace(' ', '');

	return (
		<div className={`mail-rate-advisor ${OS}`} >
			<RateAdvisor
				ratingData={ratingData}
				showFCPackage={showFCPackage}
				showParcelSelect={showParcelSelect}
				showGroundAdvantage={showGroundAdvantage}
				completionCallback={callback}
			/>
		</div>
	);
};

export default RateAdvisorWrapper;
